/**
 * 担保访问
 */

import React, {PropsWithChildren, useEffect, useState} from "react";
import {Button, CascadePicker, Form, Input, Picker} from "antd-mobile";

import "@assets/style/assure.scss"
import {isEmpty, setTitle} from "@src/util";
import ImageLoader from "@component/assure/ImageUploader";
import ImgLabel from "@component/assure/ImgLabel";
import ImageTip from "@component/assure/ImageModal"

import {demo_1, demo_5} from "@assets/images/demo/index"
import {Checkbox} from "@component/Input";
import {goto} from "@src/route";

import AssureService from "@service/AssureService";

const RelationColumns = ['父母', '配偶', '子女', '亲戚', '朋友', '其他']


enum ASSURE_PAGE {
	login,
	form,
	result
}


type AssureComponentStateType = {
	mode: ASSURE_PAGE,
	phone?: string,
	form?: AssureForm,
	message: string
}

export default class AssureComponent extends React.Component<any, AssureComponentStateType> {

	constructor(props: any) {
		super(props);
		const phone = sessionStorage.getItem("assure_phone") || undefined
		const cache = sessionStorage.getItem("assure_form_cache")
		let cacheObj: any
		if (cache && !isEmpty(cache)) {
			try {
				cacheObj = JSON.parse(cache)
			} catch (e) {
				console.log('--- no cache--')
			}
			sessionStorage.removeItem("assure_form_cache")
		}

		this.state = {
			// 有缓存或者phone不为空
			mode: (!isEmpty(phone) || cacheObj) ? ASSURE_PAGE.form : ASSURE_PAGE.login,
			phone: phone,
			message: '',
			form: cacheObj
		}
	}

	getCode() {
		const pathname = window.location.pathname;
		return pathname.split('/')[2]
	}

	onLogin(phone: string) {
		sessionStorage.setItem('assure_phone', phone)
		// todo 获取担保状态
		const code = this.getCode()
		const state: any = {mode: ASSURE_PAGE.form, phone}
		// 获取担保信息
		AssureService.getAssureDetail(code).then((rs: any) => {
			const {guaranteeApplyStatus, mobile, remark} = rs;
			const param: any = {assureTarget: rs.cusName, assureTargetPhone: rs.cusMobile}
			if (guaranteeApplyStatus == 4 || guaranteeApplyStatus == 1) {
				// 待审核及已经通过返回结果页面
				state.message = guaranteeApplyStatus == 1 ? '该客户已被担保！' : '担保申请已通过！';
				state.mode = ASSURE_PAGE.result
				// this.setState({mode: ASSURE_PAGE.result, message: remark})
			} else if (guaranteeApplyStatus == 2 && phone == mobile) {
				// todo 是否需要回填： 担保人为本人且状态为驳回 进行数据回填
				param.name = rs.name;
				param.identifynumber = rs.identifynumber;
				param.address = rs.address;
				param.relationship = rs.relationship;
				param.idf = rs.idfOssKey;
				param.idb = rs.idbOssKey;
				param.credit = rs.creditOssKeys || [];
				param.supplement = rs.supplementOssKeys || [];

				// 省市区
				param.province = rs.province
				param.provinceCode = rs.provinceCode
				param.cityCode = rs.cityCode
				param.city = rs.city
				param.countyCode = rs.countyCode
				param.county = rs.county

				state.mode = ASSURE_PAGE.form
				state.message = remark
			} else {
				state.mode = ASSURE_PAGE.form
				state.message = remark
			}
			state.form = param
			this.setState(state)
		}).catch(e => {
			alert(e)
		})
	}

	componentDidMount() {
		if (!isEmpty(this.state.phone)) {
			this.onLogin(this.state.phone || '')
		}
	}

	onSubmit(form: any) {
		const _form = {
			...form,
			mobile: this.state.phone,
			loaningInfoId: this.getCode()
		}

		AssureService.assureSubmit(_form).then(rs => {
			sessionStorage.removeItem('assure_form_cache')
			sessionStorage.removeItem('assure_phone')
			this.setState({
				mode: ASSURE_PAGE.result,
				message: '提交成功，请等待审批！'
			})
			// 跳转到结果页面
			// this.onLogin(this.state.phone || '')
		}).catch(e => {
			alert(e)
		})
	}

	render() {

		let content: any
		const {mode, phone, message, form} = this.state;
		switch (mode) {
			case ASSURE_PAGE.login:
				content = <MobileValidate onLogin={this.onLogin.bind(this)}/>
				break
			case ASSURE_PAGE.form:
				content = form && <AssureTable data={form} message={message} onSubmit={this.onSubmit.bind(this)}/>
				break
			case ASSURE_PAGE.result:
				content = <AuditResult message={message}/>
				break
		}

		return <div className="assure-page">
			{content}
			{/*<MobileValidate onLogin={this.onLogin.bind(this)}/>*/}
			{/*<AssureTable/>*/}
			{/*<AuditResult message="该客户已被担保！"/>*/}
		</div>;
	}
}

/**
 * 手机号短信验证
 * @constructor
 */
function MobileValidate(props: { onLogin: (phone: string) => void }) {

	const [form, setForm] = useState({phone: '', code: ''})
	const [count, setCount] = useState(0)
	let interval: any

	function sendCode() {
		if (isEmpty(form.phone) || !/^\d{11}$/.test(form.phone)) {
			alert('请先输入手机号！')
			return;
		}
		AssureService.getSMSCode(form.phone).then(rs => {
			if (count > 0) {
				return;
			}
			let _count = 59
			setCount(_count)
			interval = setInterval(() => {
				if (_count <= 0) {
					clearInterval(interval)
					setCount(0)
					return
				}
				setCount(--_count)
			}, 1000)
		}).catch(e => {
			console.error(e)
		})
	}

	function submit(v: any) {
		if (isEmpty(v.phone) || isEmpty(v.code)) {
			return
		}

		AssureService.smsLogin(v.phone, v.code).then(rs => {
			props.onLogin(v.phone)
		}).catch(e => {
			// 登录失败
			alert(e)
		})

	}


	useEffect(() => {
		setTitle("担保")
		return () => {
			interval && clearInterval(interval)
		}
	}, [])

	return <div className="mobile-login">
		<div className="mobile-validate">
			<Form footer={
				<Button block type="submit" className="submit-btn" size="middle">下一步</Button>
			}
				  onFinish={(v) => {
					  submit(v)
				  }}
			>
				<Form.Item name="phone">
					<Input placeholder="手机号"
						   onChange={e => {
							   setForm({
								   ...form,
								   phone: e
							   })
						   }}/>
				</Form.Item>
				<Form.Item name="code" extra={
					<div className={count == 0 ? "code-send-btn" : "code-send-btn disable"}
						 onClick={() => sendCode()}
					>
						{count > 0 ? `重新获取(${count})` : '获取验证码'}
					</div>
				}
				>
					<Input placeholder="短信验证码"/>
				</Form.Item>
			</Form>
		</div>
	</div>
}


type AssureForm = {
	assureTarget: string,
	assureTargetPhone: string,
	name?: string,
	identifynumber?: string,
	address?: string,
	relationship?: string,
	idf?: any,
	idb?: any,
	credit: Array<any>,
	supplement: Array<any>,

	provinceCode?: string,
	province?: string,
	cityCode?: string,
	city?: string,
	countyCode?: string,
	county?: string,
}

type AssureTablePropsType = {
	data: AssureForm,
	onSubmit: (form: any) => void,
	message?: string
}

type AssureTableStateType = AssureForm & {
	checked: boolean,
	areaData?: any,
	areaSelect: boolean
}


/**
 * 担保人资料表单
 * @constructor
 */
class AssureTable extends React.Component<AssureTablePropsType, AssureTableStateType> {

	constructor(props: AssureTablePropsType) {
		super(props);
		const data = props.data;
		this.state = {
			...data,
			credit: data.credit || [],
			supplement: data.supplement || [],
			checked: false,
			areaSelect: false
		}
	}


	onSubmit() {
		// todo validate
		const {
			name,
			identifynumber,
			address,
			relationship,
			idf,
			idb,
			credit,
			supplement,
			checked,
			province,
			provinceCode,
			cityCode,
			city,
			countyCode,
			county
		} = this.state;
		if (isEmpty(name)) {
			alert('请输入担保人姓名')
			return
		}
		if (isEmpty(identifynumber)) {
			alert('请输入担保人身份证号')
			return
		}

		if (!/(^\d{17}(\d|x)$)|(^\d{15}$)/i.test(identifynumber || '')) {
			alert('身份证号错误，请输入正确的身份证号！')
			return;
		}

		if (isEmpty(address)) {
			alert('请输入担保人身份证住址')
			return
		}
		if (isEmpty(relationship)) {
			alert('请选择与被担保人关系')
			return
		}

		if (isEmpty(province) || isEmpty(provinceCode) || isEmpty(city) || isEmpty(cityCode) || isEmpty(county) || isEmpty(countyCode)) {
			alert("现住址所在省市区")
			return;
		}


		if (!idf || !idf.id) {
			alert('请上传担保人身份证人像面照片')
			return
		}
		if (!idb || !idb.id) {
			alert('请上传担保人身份证国徽面面照片')
			return
		}
		if (isEmpty(credit) || credit.filter(i => !!i).length == 0) {
			alert('请上传担保人人行征信电子版图片')
			return
		}

		if (!checked) {
			alert('请阅读并同意相关协议')
			return;
		}

		const form = {
			name,
			identifynumber,
			province, provinceCode, city, cityCode, county, countyCode,
			address,
			relationship,
			idf: idf.id,
			idb: idb.id,
			credit: credit.map(c => c.id).join(','),
			supplement: supplement.map(s => s.id).join(',')
		}

		this.props.onSubmit(form)
	}

	onGotoAgreement() {
		const a = this.state;
		sessionStorage.setItem('assure_form_cache', JSON.stringify(a))
		goto('/ag/auth')

	}

	componentDidMount() {
		AssureService.getAreaList().then((rs: any) => {
			if (rs && rs.length > 0) {
				rs.forEach((l1: any) => {
					if (l1.children && l1.children.length > 0) {
						l1.children.forEach((l2: any) => {
							if (l2.children && l2.children.length > 0) {
								l2.children.forEach((l3: any) => {
									delete l3.children
								})
							}
						})
					}
				})
			}
			this.setState({areaData: rs || []})
		})
	}

	render() {
		const {message} = this.props;
		const form = this.state
		const {
			credit,
			supplement,
			checked,
			areaData,
			areaSelect,
			province,
			provinceCode,
			cityCode,
			city,
			county,
			countyCode
		} = this.state;
		const creditOSSLength = credit.length
		const coList = creditOSSLength < 100 ? credit.concat([undefined]) : credit
		const supplementLength = supplement.length
		const spList = supplementLength < 100 ? supplement.concat([undefined]) : supplement

		const area: any = [provinceCode, cityCode, countyCode]
		let areaAddress = "";
		if (!isEmpty(province)) {
			areaAddress = areaAddress + String(province)
			if (!isEmpty(city)) {
				areaAddress = areaAddress + "-" + String(city);
				if (!isEmpty(county)) {
					areaAddress = areaAddress + "-" + String(county);
				}
			}
		}

		return <div className="assure-form">
			{!isEmpty(message) && <p className="reject-reason">驳回原因：{message}</p>}
			<div>
				<FormItem label="被担保人姓名">{form.assureTarget}</FormItem>
				<FormItem label="被担保人手机号">{form.assureTargetPhone}</FormItem>
				<FormItem label="担保人姓名" required={true}>
					<input className="assure-form-input"
						   value={form.name}
						   onInput={e => {
							   const target: any = e.target;
							   const value = target.value;
							   this.setState({name: value})
						   }}/></FormItem>
				<FormItem label="身份证号" required={true}>
					<input className="assure-form-input"
						   value={form.identifynumber}
						   onInput={e => {
							   const target: any = e.target;
							   const value = target.value;
							   this.setState({identifynumber: value})
						   }}
					/></FormItem>
				<FormItem label="身份证住址" required={true}>
					<div className="assure-form-relation-selector" onClick={() => {
						this.setState({areaSelect: true})
					}}>{areaAddress || '请选择现住址所在省市区'}</div>
				</FormItem>
				<FormItem label="身份证详细住址" required={true}>
					<input className="assure-form-input"
						   value={form.address}
						   onInput={e => {
							   const target: any = e.target;
							   const value = target.value;
							   this.setState({address: value})
						   }}
					/>
				</FormItem>
				<FormItem label="与被担保人关系" required={true}>
					<RelationSelector value={form.relationship}
									  onChange={e => {
										  this.setState({relationship: e})
									  }}/>
				</FormItem>

				<div className="assure-form-title required">担保人身份证 <ImageTip
					src={demo_1}><strong>查看示图</strong></ImageTip>
				</div>
				<div className="assure-form-img-box">
					<ImageLoader src={form.idf?.osskeySmall}
								 previewSrc={form.idf?.osskey}
								 onChange={e => {
									 this.setState({idf: e})
								 }}
								 onRemove={() => {
									 this.setState({idf: undefined})
								 }}
					>
						<ImgLabel type={'normal'} label={"请上传担保人身份证 人像面照片1张"}/>
					</ImageLoader>

					<ImageLoader src={form.idb?.osskeySmall}
								 previewSrc={form.idb?.osskey}
								 onChange={e => {
									 this.setState({idb: e})
								 }}
								 onRemove={() => {
									 this.setState({idb: undefined})
								 }}>
						<ImgLabel type={'normal'} label={"请上传申请人身份证 国徽面照片1张"}/>
					</ImageLoader>
				</div>

				<div className="assure-form-title required">征信-人行征信电子版<span>（至少一张）</span> <ImageTip
					src={demo_5}><strong>查看示图</strong></ImageTip></div>
				<span>手机银行APP可申请</span>
				<div className="assure-form-img-box">
					{
						coList.map((item, index) => {
							const key = item?.id || Math.random().toFixed(6);
							return <ImageLoader key={key}
												src={item?.osskeySmall}
												previewSrc={item?.osskey}
												onChange={e => {
													if (e) {
														credit[index] = e
														this.setState({credit})
													}
												}}
												onRemove={() => {
													credit.splice(index, 1)
													this.setState({credit})
												}}>
								<ImgLabel type={'normal'} label={"请上传征信-人行征信电子版"}/>
							</ImageLoader>
						})
					}
				</div>
				<div className="assure-form-title">其他资料<span>（非必填）</span></div>
				<div className="assure-form-img-box">
					{
						spList.map((item, index) => {
							const key = item?.id || Math.random().toFixed(6);
							return <ImageLoader key={key}
												src={item?.osskeySmall}
												previewSrc={item?.osskey}
												onChange={e => {
													if (e) {
														supplement[index] = e
														this.setState({supplement})
													}
												}}
												onRemove={() => {
													supplement.splice(index, 1)
													this.setState({supplement})
												}}>
								<ImgLabel type={'normal'} label={"补充资料图示"}/>
							</ImageLoader>
						})
					}
				</div>
				<CascadePicker title="现住址所在省市区"
							   options={areaData || []}
							   visible={areaSelect}
							   value={area}
							   onClose={() => {
								   this.setState({areaSelect: false})
							   }}
							   onConfirm={(v) => {
								   console.log('confirm : ', v)
								   const provinceItem = areaData?.find((p: any) => p.value == v[0])
								   const provinceCode = provinceItem?.value;
								   const province = provinceItem?.label;
								   const cityItem = provinceItem?.children?.find((c: any) => c.value == v[1])
								   const city = cityItem?.label;
								   const cityCode = cityItem?.value;
								   const countryItem = cityItem?.children?.find((c: any) => c.value == v[2])
								   const county = countryItem?.label;
								   const countyCode = countryItem?.value;

								   this.setState({
									   areaSelect: false,
									   province,
									   provinceCode,
									   city,
									   cityCode,
									   county,
									   countyCode
								   })
							   }}

				/>
				{/* 协议 */}
				<div className="agreement" style={{marginTop: '20px'}}>
					<p><Checkbox checked={checked}
								 style={{marginRight: '5px'}}
								 onClick={() => {
									 this.setState({checked: !checked})
								 }}/>我已阅读并同意
						<strong
							onClick={(e) => {
								e.stopPropagation()
								this.onGotoAgreement()
							}}>《信息查询授权书》</strong>
					</p>
				</div>
				<div>
					<Button
						onClick={this.onSubmit.bind(this)}
						style={{
							backgroundColor: '#358163',
							color: '#FFF',
							float: 'right',
							padding: '8px 26px'
						}}>提交</Button>
				</div>
			</div>
		</div>
	}
}

/**
 * 担保审核结果
 * @constructor
 */
function AuditResult(props: { message: string }) {
	const {message} = props;
	return <div className="result-box">
		<div className="icon-success"/>
		<div>{message}</div>
	</div>
}

function FormItem(props: PropsWithChildren<{ label?: string, colon?: boolean, required?: boolean }>) {
	const {label, children, colon, required} = props;
	const classNames = ['assure-form-item']
	if (isEmpty(colon) || colon) {
		classNames.push('colon')
	}
	if (required) {
		classNames.push('required')
	}

	return <div className={classNames.join(' ')}>
		{
			!isEmpty(label) && <div className="assure-form-item-label">{label}</div>
		}
		<div className="assure-form-item-value">{children}</div>
	</div>
}


function RelationSelector(props: { value?: string, onChange?: (v?: string) => void }) {
	const {value, onChange} = props;
	const [visible, setVisible] = useState(false);
	const pickerValue = !isEmpty(value) && value ? [value] : undefined;

	const columns = RelationColumns.map(r => ({label: r, value: r}))

	return <div className="assure-form-relation-selector"
				onClick={() => {
					setVisible(true)
				}}>
		{value || '请选择'}
		<Picker columns={[columns]} visible={visible} onClose={() => setVisible(false)}
				value={pickerValue}
				onConfirm={(v) => {
					const val = v ? v[0] as string : undefined
					onChange && onChange(val)
				}}
		/>
	</div>
}
